import React from 'react';
import { AppTabs } from 'qcc';
import { default as IndexGrid } from './IndexGrid';
import { default as IndexLoginGrid } from './IndexLoginGrid';
import './index.less'

const tabs: string[] = ['操作日志', '登录日志'];
export default class extends React.Component<IPage> {
  state = { tabIndex: 0 }

  tabChg = (tabIndex: number) => {
    this.setState({ tabIndex })
  }

  render() {
    return (
      <div className='page-application-audit-container'>
        <AppTabs tabs={tabs} onChange={this.tabChg}></AppTabs>
        <div className='page-audit-grid-container'>
          {this.state.tabIndex === 0 ? <IndexGrid /> : <IndexLoginGrid />}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/page/application/audit/index.tsx